export enum ZIndex {
  Background = 0,
  Border = 1,
  Artifact = 2,
  CTA = 3,
  Player = 4,
  Cursor = 5,
  TeleportMenu = 6,
}
